/*
 * ORGAINIC Buttons: Einblend-Effekt beim ersten Sichtbarwerden und Lichtwelle
 * vom Klickpunkt für den Add-to-Cart-Button. Optik siehe orgainic-buttons.css.
 */
(function () {
  // Nur der Add-to-Cart-Button beim Produkt bekommt Einblenden und Lichtwelle,
  // alle anderen Buttons bleiben ruhig (siehe orgainic-buttons.css).
  var SELECTOR = [
    '.l-add-to-cart-button',
    '.cvs__atc',
    'form[action*="/cart/add"] button[type=submit].button--large'
  ].map(function (s) { return s + ':not(.button--sold-out)'; }).join(',');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Einblenden
  var io = null;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        el.classList.add('ob-reveal');
        el.addEventListener('animationend', function done(e) {
          if (e.target !== el) return;
          el.classList.remove('ob-reveal');
          el.removeEventListener('animationend', done);
        });
      });
    }, { threshold: 0.6 });
  }

  function observe(root) {
    if (!io) return;
    var nodes = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__obSeen || el.offsetParent === null) continue;
      el.__obSeen = true;
      io.observe(el);
    }
  }

  // Lichtwelle beim Klick
  document.addEventListener('pointerdown', function (e) {
    if (reduceMotion || (e.button !== undefined && e.button !== 0)) return;
    var btn = e.target.closest && e.target.closest(SELECTOR);
    if (!btn || btn.disabled || btn.tagName === 'INPUT') return;
    var rect = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'ob-ripple';
    ripple.setAttribute('aria-hidden', 'true');
    ripple.style.left = (e.clientX - rect.left) + 'px';
    ripple.style.top = (e.clientY - rect.top) + 'px';
    ripple.style.setProperty('--ob-ripple-scale', String(Math.ceil(Math.max(rect.width, rect.height) / 6)));
    btn.appendChild(ripple);
    ripple.addEventListener('animationend', function () { ripple.remove(); });
    setTimeout(function () { if (ripple.parentNode) ripple.remove(); }, 1200);
  }, { passive: true });

  function init() {
    observe(document);
    if ('MutationObserver' in window && io) {
      var timer = null;
      new MutationObserver(function () {
        if (timer) return;
        timer = setTimeout(function () {
          timer = null;
          observe(document);
        }, 300);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
